var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 7.98438V4H6.73661C6.30692 4 6 4.32227 6 4.70312V18.2969C6 18.707 6.30692 19 6.73661 19H17.0491C17.4481 19 17.7857 18.707 17.7857 18.2969V8.6875H13.6116C13.1819 8.6875 12.875 8.39453 12.875 7.98438ZM14.8393 14.8984C14.8393 15.1035 14.6551 15.25 14.471 15.25H9.31473C9.09989 15.25 8.94643 15.1035 8.94643 14.8984V14.6641C8.94643 14.4883 9.09989 14.3125 9.31473 14.3125H14.471C14.6551 14.3125 14.8393 14.4883 14.8393 14.6641V14.8984ZM14.8393 13.0234C14.8393 13.2285 14.6551 13.375 14.471 13.375H9.31473C9.09989 13.375 8.94643 13.2285 8.94643 13.0234V12.7891C8.94643 12.6133 9.09989 12.4375 9.31473 12.4375H14.471C14.6551 12.4375 14.8393 12.6133 14.8393 12.7891V13.0234ZM14.8393 10.9141V11.1484C14.8393 11.3535 14.6551 11.5 14.471 11.5H9.31473C9.09989 11.5 8.94643 11.3535 8.94643 11.1484V10.9141C8.94643 10.7383 9.09989 10.5625 9.31473 10.5625H14.471C14.6551 10.5625 14.8393 10.7383 14.8393 10.9141ZM17.7857 7.57422C17.7857 7.39844 17.6936 7.22266 17.5709 7.07617L14.5631 4.20508C14.4096 4.08789 14.2254 4 14.0413 4H13.8571V7.75H17.7857V7.57422Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAlt);
export default __webpack_public_path__ + "static/media/file-alt.17301be6e767b90efbcf73d75ce54fdf.svg";
export { ForwardRef as ReactComponent };